import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';

import { saveAs } from 'file-saver';
import { LoadingPanelService } from '../../shared/loading-panel/loading-panel.service';
import { GenericModalService } from '../../shared/generic-modal/generic-modal.service';
import { PartnerExportOptions } from '../models/partner-export-options';
import { PartnerExportService } from './partner-export.service';
import { PartnerExportModalComponent } from '../partner-export-modal/partner-export-modal.component';

@Injectable({
    providedIn: 'root'
})
export class PartnerExportUiService {
    constructor(
        private partnerExportService: PartnerExportService,
        private loadingPanelService: LoadingPanelService,
        private modalService: GenericModalService) {
    }

    public async exportPartners(partnerIds: number[]) {
        try {
            const exportOptions: PartnerExportOptions = await this.modalService.openComponent(PartnerExportModalComponent);
            if (exportOptions) {
                this.loadingPanelService.showLoadingPanelDirect('Exporting partners...');

                await this.partnerExportService.exportPartners(partnerIds, exportOptions);
            }
        }
        catch (err) {
            // Occurs if the user click the close button on the dialog
        }
        finally {
            this.loadingPanelService.hideLoadingPanel();
        }
    }
}
